// import { getAuth } from '@firebase/auth';
import {
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,

    query,
    serverTimestamp,
    updateDoc,
    where,
    addDoc, FieldValue
} from 'firebase/firestore'
import {db} from '../firebase';
import {returnAuthBool} from "../components/CONSTANTS";
import {setDoc} from "@firebase/firestore";
import {merge} from "chart.js/helpers";


const usersCollectionRef = collection(db, "User");


export const getUsersAPI = async (company) => {


    const q = query(usersCollectionRef, await where("company", "==", company));

    return (await getDocs(q)).docs.map((doc) => ({...doc.data(), id: doc.id}));
}

export const updateUser = async (id, firstname, lastname, accountType) => {
    const docRef = doc(db, "User", id);
    let insertValue = returnAuthBool(accountType);

    if (firstname != null) {
        await setDoc(docRef, {
            firstName: firstname
        }, {merge: true})
    }
    if (lastname != null) {
        await setDoc(docRef, {
            lastName: lastname
        }, {merge: true})
    }


    if (accountType != null) {
        await setDoc(docRef, {
            allowWeb: insertValue
        }, {merge: true})
    }


}
export const removeUser = async (id) => {

    if (id)
        await deleteDoc(doc(db, "User", id));

}


export const getUserInfo = async (match) => {

    let object = {}

    const docRef = doc(db, 'User', match);

    await getDoc(docRef).then(function (snapshot) {
        object = snapshot.data();
    });

    return object;

}

export const getUserCompany = async (match) => {


    const docRef = doc(db, 'User', match);

    const docsnap = await getDoc(docRef);
    if (docsnap.exists() && docsnap.data().allowWeb === true) {

        return docsnap.data().company;
    } else {
        console.error()
    }


}

export const addMessageToDB = async (firstname, lastname, email, subject, message, uid) => {

    await addDoc(collection(db, "Messages"), {
        userUID: uid,
        firstname: firstname,
        lastname: lastname,
        email: email,
        subject: subject,
        message: message,
        messageSent: serverTimestamp()
    });
}


